import { Injectable } from '@angular/core';
import { IMAGE_STATUS } from '@app/shared/constants/image';
import { BehaviorSubject, Observable } from 'rxjs';
import { ImageSnippet } from '../components/image-picker/image-snippet.model';
import { Image } from '../models/image.model';

@Injectable()
export class ImageSnippetService {
    private imageSnippetSubject: BehaviorSubject<ImageSnippet>;

    get imageSnippet(): ImageSnippet {
        return this.imageSnippetSubject.getValue();
    }

    get imageSnippet$(): Observable<ImageSnippet> {
        return this.imageSnippetSubject.asObservable();
    }

    constructor() {
        this.imageSnippetSubject = new BehaviorSubject({
            status: IMAGE_STATUS.EMPTY,
            source: '',
            file: undefined,
        });
    }

    loadImageSnippet(source: File | Blob | Image) {
        this.setImageSnippet(
            IMAGE_STATUS.LOADING,
            this.imageSnippet.source,
            this.imageSnippet.file
        );

        if (Object.keys(source).includes('source')) {
            this.setImageSnippet(IMAGE_STATUS.FULFILLED, source['source']);
        } else {
            const reader = new FileReader();
            reader.onload = (event: any) => {
                const file: File = source instanceof File ? source : undefined;
                this.setImageSnippet(IMAGE_STATUS.FULFILLED, event.target.result, file);
            };

            reader.readAsDataURL(source as Blob);
        }
    }

    setInitStatus() {
        this.setImageSnippet(IMAGE_STATUS.INIT);
    }

    setEmptyStatus() {
        this.setImageSnippet(IMAGE_STATUS.EMPTY);
    }

    private setImageSnippet(status: IMAGE_STATUS, source = '', file: File = undefined): void {
        this.imageSnippetSubject.next({ status, source, file });
    }
}
